import * as React from 'react';
import '../../context/actions.js';
import '../../context/reducer.js';
import { useProductData } from '../../context/product-context-hooks.js';
import '../../context/ProductContext.js';
import { useCmsData } from '../../context/CmsContext.js';
import { BrandPromotion } from './BrandPromotion.js';

const BrandPromotionContainer = ({ className , isClickable , size  })=>{
    const { brandPromotions  } = useCmsData();
    const { product: { brandName  } ,  } = useProductData();
    return /*#__PURE__*/ React.createElement(BrandPromotion, {
        brandPromotions: brandPromotions,
        brandName: brandName,
        className: className,
        isClickable: isClickable,
        size: size
    });
};

export { BrandPromotionContainer };
//# sourceMappingURL=BrandPromotionContainer.js.map
